import { useTrainingReport } from '@/api/reports';
import { LoadingSpinner } from '@/components/shared/loading-spinner';
import { ErrorMessage } from '@/components/shared/error-message';
import { EmptyState } from '@/components/shared/empty-state';
import { Users, AlertTriangle, CheckCircle, Clock } from 'lucide-react';
import { SummaryCard } from './summary-card';
import { STATUS_LABELS } from '../_labels';

export function TrainingSection() {
  const { data, isLoading, error } = useTrainingReport();

  if (isLoading) return <LoadingSpinner />;
  if (error) return <ErrorMessage message="No se pudo cargar el reporte de capacitación." />;
  if (!data) return <EmptyState title="Sin datos" description="No hay datos disponibles." />;

  return (
    <div className="space-y-6">
      {/* Summary cards */}
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <SummaryCard label="Inscripciones" value={data.total_enrollments} icon={Users} />
        <SummaryCard label="Completados" value={data.completed} icon={CheckCircle} />
        <SummaryCard label="Activos" value={data.active} icon={Clock} />
        <SummaryCard label="Vencidos" value={data.expired} icon={AlertTriangle} />
      </div>

      {/* Table */}
      {data.enrollments.length > 0 && (
        <div className="overflow-x-auto rounded-xl border border-border">
          <table className="w-full text-sm">
            <thead className="border-b border-border bg-muted/50">
              <tr>
                <th className="px-4 py-3 text-left font-medium text-muted-foreground">Usuario</th>
                <th className="px-4 py-3 text-left font-medium text-muted-foreground">Curso</th>
                <th className="px-4 py-3 text-left font-medium text-muted-foreground">Estado</th>
                <th className="px-4 py-3 text-right font-medium text-muted-foreground">Progreso</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {data.enrollments.slice(0, 50).map((e) => (
                <tr key={e.id} className="hover:bg-muted/30">
                  <td className="px-4 py-3 text-card-foreground">
                    {e.user.first_name} {e.user.last_name}
                  </td>
                  <td className="px-4 py-3 text-card-foreground">{e.course.title}</td>
                  <td className="px-4 py-3">
                    <span className="rounded-full bg-muted px-2 py-0.5 text-xs font-medium">
                      {STATUS_LABELS[e.status] ?? e.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right font-medium">{e.progress}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
